import { createFileRoute } from '@tanstack/react-router';
import BookmarkListPage from '../components/BookmarkListPage';
import { useUserPreferences } from '../hooks/useUserPreferences';
import { useLikedBookmarks } from '../services/dataHooks';
import { validateListPageSearch } from '../utils/listPageSearch';

export const Route = createFileRoute('/_app/liked/')({
  validateSearch: validateListPageSearch,
  component: LikedIndexPage,
});

function LikedIndexPage() {
  const search = Route.useSearch();
  const page = search.page ?? 1;
  const navigate = Route.useNavigate();
  const { preferences } = useUserPreferences();
  const {
    bookmarks,
    hasMore,
    isLoading: isBookmarkCollectionLoading,
  } = useLikedBookmarks(page);

  const updatePageSearch = (nextPage: number) => {
    const safePage = Math.max(1, nextPage);
    navigate({
      replace: true,
      search: (prev) => {
        if (safePage <= 1) {
          if (prev.page === undefined) return prev;
          const { page: _page, ...rest } = prev;
          return rest;
        }
        if (prev.page === safePage) return prev;
        return { ...prev, page: safePage };
      },
    });
  };

  return (
    <BookmarkListPage
      mode="liked"
      bookmarks={bookmarks}
      currentPage={page}
      condensedView={preferences.bookmarkList.view === 'condensed'}
      showThumbnails={preferences.bookmarkList.thumbnails}
      isLoading={isBookmarkCollectionLoading}
      hasMore={hasMore}
      onPageChange={updatePageSearch}
    />
  );
}
